import { SourceBasedExpression } from '../Expression.js';
export class SizeExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource().evaluate(visitor, localVariables);
        if (source && (source instanceof Array || typeof source === 'string')) {
            return source.length;
        }
        else {
            return 0;
        }
    }
}
//# sourceMappingURL=SizeExpression.js.map